import { render, staticRenderFns } from "./TotemsTitle.vue?vue&type=template&id=1bef2920&scoped=true"
import script from "./TotemsTitle.vue?vue&type=script&lang=js"
export * from "./TotemsTitle.vue?vue&type=script&lang=js"
import style0 from "./TotemsTitle.vue?vue&type=style&index=0&id=1bef2920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef2920",
  null
  
)

export default component.exports